import { useState } from 'react'
import { NotificationSettings, SecuritySettings } from '../components/pages/settings'

const SETTINGS_TABS = [
  {
    id: 'notifications',
    name: 'Notifications',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
    ),
    component: NotificationSettings,
  },
  {
    id: 'security',
    name: 'Security',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
      </svg>
    ),
    component: SecuritySettings,
  },
]

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('notifications')

  const activeTabConfig = SETTINGS_TABS.find(tab => tab.id === activeTab) || SETTINGS_TABS[0]
  const ActiveComponent = activeTabConfig.component

  return (
    <div className="flex flex-col lg:flex-row gap-6 h-full">
      {/* Left Sidebar - Settings Tabs */}
      <div className="w-full lg:w-64 flex-shrink-0">
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
          <div className="p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">Settings</h2>
            <p className="text-xs text-gray-500 mt-1">Manage your preferences</p>
          </div>
          <nav className="p-2">
            {SETTINGS_TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors mb-1 ${
                  activeTab === tab.id
                    ? 'bg-blue-50 text-blue-700 font-medium border border-blue-200'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <span className={activeTab === tab.id ? 'text-blue-600' : 'text-gray-500'}>
                  {tab.icon}
                </span>
                <span className="text-sm flex-1 text-left">{tab.name}</span>
                {activeTab === tab.id && (
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                )}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Right Side - Settings Content */}
      <div className="flex-1 min-w-0">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">{activeTabConfig.name}</h1>
          <p className="text-gray-600 mt-1">
            Manage your {activeTabConfig.name.toLowerCase()} settings and preferences.
          </p>
        </div>
        <ActiveComponent />
      </div>
    </div>
  )
}

export default SettingsPage

